import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { getAssetVersionDimensions } from '../../../gallery/lib/get-asset-version-dimensions';
import { getAllowedDownloadSizes } from '../../../lib/convert-gallery-download-size';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';

@Component({
  selector: 'app-download-size-selection',
  templateUrl: './download-size-selection.component.html',
  styleUrls: ['./download-size-selection.component.scss'],
  imports: [ButtonMenuItemComponent, LowerCasePipe, CapitalizePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadSizeSelectionComponent {
  readonly galleryPermissions = input<GalleryDto['permissions']>(undefined);
  readonly asset = input<AssetDto>(undefined);
  readonly gallery = input<GalleryDto>(undefined);
  onSelect = output<number>();

  readonly sizes = computed(() => {
    const gallery = this.gallery();
    const permissions = this.galleryPermissions();
    const asset = this.asset();
    if (!gallery || !permissions || !asset) return [];
    return getAllowedDownloadSizes(gallery.download_media_size, permissions, asset).sizes.map(size => {
      return {
        width: this.getWidth(size.size),
        height: this.getHeight(size.size),
        ...size,
      };
    });
  });

  readonly allowOriginalDownload = computed(() => {
    const gallery = this.gallery();
    const permissions = this.galleryPermissions();
    const asset = this.asset();
    if (!gallery || !permissions || !asset) return [];
    return getAllowedDownloadSizes(gallery.download_media_size, permissions, asset).allowOriginalDownload;
  });

  private getWidth(size: number) {
    const dimensions = getAssetVersionDimensions(this.asset().version_data);
    if (!dimensions?.width) return;
    const aspect = dimensions.height / dimensions.width;
    if (aspect < 1) return size;
    return Math.round(size / aspect);
  }

  private getHeight(size: number) {
    const dimensions = getAssetVersionDimensions(this.asset().version_data);
    if (!dimensions?.width) return;
    const aspect = dimensions.height / dimensions.width;
    if (aspect > 1) return size;
    return Math.round(size * aspect);
  }
}
